import { Chip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DateTime } from "luxon";
import { createElement, useMemo } from "react";
import { IconType } from "react-icons";
import { TbArrowDown, TbBriefcase, TbDoorExit, TbLogin2 } from "react-icons/tb";

import { softColors } from "@/constants/colors";
import { UserLifeCycle } from "@/types/user.types";

export function UserLifecycleInfoTimeLineItemRow({
    isActive,
    icon,
    title,
    description,
    time,
}: {
    isActive: boolean;
    icon: IconType;
    title: string;
    description: string;
    time: string;
}) {
    const date = (time && DateTime.fromISO(time).setZone("Europe/Istanbul").setLocale("tr")) || null;

    return (
        <div className=" relative flex justify-between items-center">
            <span
                className={
                    "absolute flex items-center justify-center w-8 h-8  shadow rounded-full -left-4 ring-1   z-10  shadow " +
                    (isActive ? " ring-indigo-400" : " ring-gray-300")
                }
                style={{
                    backgroundColor: isActive ? softColors.indigo.bg : grey[200],
                }}
            >
                {createElement(icon, { size: 20, color: isActive ? softColors.indigo.text : softColors.grey.text })}
            </span>
            <div className="flex flex-col   min-h-10  px-8">
                <div className="font-semibold text-sm">{title}</div>
                <span className="text-gray-500 font-normal text-sm">{description}</span>
            </div>
            <div className=" shrink-0 grow-0  ml-auto text-right">
                {(date && (
                    <>
                        <div className="text-gray-500 font-normal">{date.toFormat("d LLL")}</div>
                        <div className="text-gray-900 font-medium">{date.toFormat("HH:mm")}</div>
                    </>
                )) || <div className="w-full h-full grid place-content-center justify-center">-</div>}
            </div>
        </div>
    );
}
export function UserLifecycleInfoTimelineItem({ lifecycle, index }: { lifecycle: UserLifeCycle; index: number }) {
    const isActive = !lifecycle.leavedAt;
    const workingDuration = useMemo(() => {
        if (!lifecycle || !lifecycle.startedAt) return "";
        const { startedAt, leavedAt } = lifecycle;
        const endTime = (leavedAt && DateTime.fromISO(leavedAt)) || DateTime.now();

        const diff = endTime.diff(DateTime.fromISO(startedAt), ["months", "days"]);

        return `${Math.floor(diff.months)} ay ${Math.round(diff.days)} gün`;
    }, [lifecycle]);

    return (
        <>
            <div className="flex gap-5 items-center">
                <div
                    className={
                        "text-base font-medium w-4 grow-0 shrink-0 " +
                        (isActive ? " text-indigo-700" : " text-gray-700")
                    }
                >
                    {index + 1}.
                </div>
                <div
                    className={
                        "border shadow-sm grow  rounded-lg p-4 " +
                        (isActive ? " border-indigo-200" : " border-gray-200")
                    }
                >
                    <ol className="relative   flex    flex-col gap-2 py-2   mx-2 ">
                        <div
                            className=" absolute top-0  -left-[1px] w-[2px]  h-full"
                            style={{ backgroundColor: isActive ? softColors.indigo.hover : softColors.grey.hover }}
                        ></div>

                        <UserLifecycleInfoTimeLineItemRow
                            isActive={isActive}
                            icon={TbLogin2}
                            title="Giriş"
                            description="Kullanıcının işe giriş tarihini belirtir."
                            time={lifecycle.startedAt}
                        />
                        <Chip
                            className=" !w-fit shrink-0 grow-0 mx-auto bg-gray-300 font-medium"
                            icon={createElement(TbArrowDown, { fontSize: 10, color: "gray" })}
                            label={`Çalışma süresi: ${workingDuration}`}
                            size="small"
                        />

                        {isActive ? (
                            <UserLifecycleInfoTimeLineItemRow
                                isActive={isActive}
                                icon={TbBriefcase}
                                title="Aktif Çalışan"
                                description="Kullanıcı aktif olarak çalışmaktadır."
                                time={""}
                            />
                        ) : (
                            <UserLifecycleInfoTimeLineItemRow
                                isActive={isActive}
                                icon={TbDoorExit}
                                title="Çıkış"
                                description="Kullanıcının işten çıkış tarihini belirtir."
                                time={lifecycle.leavedAt}
                            />
                        )}
                    </ol>
                </div>
            </div>
        </>
    );
}
